<valg-table
    [columnDefinition]="referendumStatusColumnDef"
    [data]="data"
    [itemName]="'election_overview.fa_election.table.item_name' | translate"
    [title]="election?.title"
    [hasPagination]="false"
    [displayItemCount]="false"
    [hasMainActionButton]="false">
    <h2 class="m-0 text--f20 text--500">{{ election?.title }}</h2>
</valg-table>